import { FC } from "react";
import { useDispatch } from "react-redux";

import { LoginPopupState, PopupTypes } from "./../../../store/types/Popup";
import { changeCurrentLoginPopupState } from "./../../../store/ui/actionCreators";
import Button, { ButtonVariant } from "./../../../libs/Button";
import usePopup from "./../../../hooks/usePopup";

import styles from "./style.module.scss";

const AuthButtons: FC = () => {
    const dispatch = useDispatch();
    const { onOpen: onPopupOpen } = usePopup();

    const getOpenPopupHandler = (popupType: PopupTypes, newCurrentLoginPopupState: LoginPopupState) => () => {
        onPopupOpen(popupType);
        dispatch(changeCurrentLoginPopupState(newCurrentLoginPopupState));
    };

    return (
        <div className={styles.wrapper}>
            <Button
                variant={ButtonVariant.PAPER}
                text="Log In"
                big={false}
                className={styles.logInBtn}
                onClick={getOpenPopupHandler(PopupTypes.LOGIN_SIGNUP, LoginPopupState.LOGIN)}
            />

            <Button
                text="Sign Up"
                big={false}
                className={styles.signUpBtn}
                onClick={getOpenPopupHandler(PopupTypes.LOGIN_SIGNUP, LoginPopupState.SIGNUP)}
            />
        </div>
    );
};

export default AuthButtons;
